import { StockChartGeographicalDataService } from './stock-chart-geographical-data.service';
import { StockChartConfig, StockChartGeographicConfig, StockChartGeographicAPIConfig } from './stock-chart/stock-chart-model';
/**
 * @packageDocumentation
 * @module StockChartModule
 */
import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject, Subscription, config } from 'rxjs';
import { convertToFloat, isEmptyObject, isEmptyField, isObject, isEmptyArray } from './stock-chart-shared/stock-chart-shared-services/stock-chart-util.service';
import { ChartApplicationConfig, StockChartApplicationAPIConfig, FilterConfig } from './stock-chart/stock-chart-model';
import { isNullOrUndefined, isNumber } from 'util';
import { StockChartHttpService } from './stock-chart-shared/stock-chart-shared-services/stock-chart-http.service';
import { StockChartDataService } from './stock-chart-shared/stock-chart-shared-services/stock-chart-data.service';
import { StockChartUnitConversionService } from './stock-chart-shared/stock-chart-shared-services/stock-chart-unit-conversion.service';
import { StockChartCustomizableService } from './stock-chart-customizable.service';

@Injectable({
  providedIn: 'root'
})
export class StockChartService {

  // Initiliazation subjects
  initSubjects: { [key: string]: { [key: string]: BehaviorSubject<any> } } = {};


  filterFormSubjects: { [key: string]: BehaviorSubject<any> } = {};
  filterData = {};
  datePickerSubjects: { [key: string]: BehaviorSubject<any> } = {};
  datePickerData = {};
  stockCartConfigSubjects: { [key: string]: BehaviorSubject<any> } = {};
  stockChartConfigData = {};
  componentSubscription = new BehaviorSubject<any>({});
  dataSubjectsList: { [key: string]: { [key: string]: Subject<any> } } = {};
  subscriptionList: Subscription[] = [];
  constructor(
    private httpService: StockChartHttpService,
    private dataService: StockChartDataService,
    private stockChartCustomService: StockChartCustomizableService,
    private stockChartGeoService: StockChartGeographicalDataService
  ) {
    // this.filterForm.pipe(
    //   finalize(() => this.resetFilterData())
    // );
    // this.datePickerForm.pipe(
    //   finalize(() => this.resetDatePickerData())
    // );
    // this.stockCartConfigSubject.pipe(
    //   finalize(() => this.resetStockChartData())
    // );
  }
  /**
   * Clear all the subjects related to stock chart
   * @param id stock chart id
   */
  clearAllSubjectsForChart(id) {
    if (this.initSubjects[id]) {
      delete this.initSubjects[id];
    }
    if (this.stockCartConfigSubjects[id]) {
      delete this.stockCartConfigSubjects[id];
      delete this.stockChartConfigData[id];
    }

    if (this.datePickerSubjects[id]) {
      delete this.datePickerSubjects[id];
      delete this.datePickerData[id];
    }

    if (this.filterFormSubjects[id]) {
      delete this.filterFormSubjects[id];
      delete this.filterData[id];
    }

    if (this.dataSubjectsList[id]) {
      delete this.dataSubjectsList[id];
    }
  }
  /**
   * return the by default filter count
   * @param config filter config from the stock config
   */
  getByDefaultFilterCount(config: FilterConfig[]) {
    let count = 0;
    config.forEach(filter => {
      if (!isEmptyField(filter.config.byDefaultSelect)) {
        count += 1;
      }
    });
    return count;
  }
  /**
   * create filter subject based on id
   * @param id Stock chart id
   */
  createFilterSubject(id) {
    if (!this.filterFormSubjects[id]) {
      this.filterFormSubjects[id] = new BehaviorSubject<any>({});
    }
    if (!this.filterData[id]) {
      this.filterData[id] = {};
    }
  }
  /**
   *
   * @param id stock chart id
   * @param data filter data
   * @param from page which is getting
   * @param changedFields changed fields array
   * @param configObject config object if any
   */
  updateFilterForm(id, data, from?: string, changedFields?: any[], configObject?: any) {
    if (from != 'compare' && JSON.stringify(data) === JSON.stringify(this.filterData[id])) {
      return;
    }
    this.filterData[id] = from != 'compare' ? data : {};
    const nextData: any = {};
    nextData.data = data;
    if (changedFields && changedFields.length > 0) {
      nextData.changedFields = changedFields;
    }
    if (!isEmptyObject(configObject)) {
      nextData.configObject = configObject;
    }
    if (!isEmptyField(from)) {
      nextData.from = from;
    }
    this.filterFormSubjects[id].next(nextData);
  }
  /**
   * create date picker subject baesd on id
   * @param id stock chart id
   */
  createDatePickerSubject(id) {
    if (!this.datePickerSubjects[id]) {
      this.datePickerSubjects[id] = new BehaviorSubject<any>({});
    }
    if (this.datePickerData[id]) {
      this.datePickerData[id] = {};
    }
  }
  /**
   * create stock chart config subjects
   * @param id stock chart id
   */
  createStockChartSubject(id) {
    if (!this.stockCartConfigSubjects[id]) {
      this.stockCartConfigSubjects[id] = new BehaviorSubject<any>({});
    }
    if (this.stockChartConfigData[id]) {
      this.stockChartConfigData[id] = {};
    }
  }
  /**
   * update the stock config subject
   * @param id stock chart id
   * @param data stock chart config
   */
  updateStockChartConfigData(id, data) {
    this.stockCartConfigSubjects[id].next(data);
  }

  /**
   * will update the date picker config
   * @param id stock chart id
   * @param data datepicker data
   * @param changedFields changed fields
   */
  updateDatePickerForm(id, data, changedFields?: any[]) {
    // if (JSON.stringify(data) === JSON.stringify(this.datePickerData)) {
    //   return;
    // }
    this.datePickerData[id] = data;
    this.datePickerSubjects[id].next(data);
  }
  /**
   * reset the date picker data
   * @param id stock chart id
   */
  resetDatePickerData(id) {
    this.datePickerData[id] = {};
    try {
      delete this.datePickerSubjects[id];
    } catch (e) {
      console.log(e, 'error while deleting ');
    }
  }
  /**
   * reset the initialized subjects ex: filter, date init subjects
   * @param id stock chart id
   */
  resetInitSubjects(id) {
    try {
      delete this.initSubjects[id];
    } catch (e) {
      console.log(e, 'error while deleting ');
    }
  }
  /**
   * reset stock chart config subjects
   * @param id stock chart id
   */
  resetConfigSubjects(id) {
    this.stockChartConfigData[id] = {};
    try {
      delete this.stockCartConfigSubjects[id];
    } catch (e) {
      console.log(e, 'error while deleting ');
    }
  }
  /**
   * reset the filter data
   * @param id stock chart id
   */
  resetFilterData(id?) {
    this.filterData[id] = {};
    try {
      delete this.filterData[id];
    } catch (e) {
      console.log(e, 'error while deleting ');
    }
  }
  /**
   * return the data from the api config for application
   * @param stockChartId stock chart id
   * @param apiConfig apiConfig for application
   * @param apiId apiId in the apiConfig
   * @param isStockChartFormat whether need to format to stock chart array
   */
  getDataFromAPIConfig(stockChartId: string, apiConfig: StockChartApplicationAPIConfig, apiId?: string, isStockChartFormat?: boolean): Observable<any> {
    const dataObject: any = {};
    const dataSubscription = Subscription;
    let subscription: Observable<any> = this.httpService.placeAPICall(apiConfig);
    let isHTTPCall = true;
    if (isEmptyField(this.dataSubjectsList[stockChartId])) {
      this.dataSubjectsList[stockChartId] = {};
    }
    if (!isEmptyField(this.dataSubjectsList[stockChartId][apiId])) {
      subscription = this.dataSubjectsList[stockChartId][apiId];
      isHTTPCall = false;
    } else {
      this.dataSubjectsList[stockChartId][apiId] = new Subject<any>();
    }
    return new Observable(observer => {
      subscription.subscribe(data => {
        if (!isEmptyField(apiConfig.dataFormatter)) {
          if (!isEmptyObject(apiConfig.dataFormatter) && !isEmptyField(apiConfig.dataFormatter.functionName)) {
            try {
              data = this.stockChartCustomService[apiConfig.dataFormatter.functionName](data, apiConfig.dataFormatter.paramObject);
            } catch (e) {
              console.log('No data formatter exists in stock chart service');
            }
          } else if (apiConfig.dataFormatter.formatter) {
            data = apiConfig.dataFormatter.formatter(data);
          }
        }
        if (isHTTPCall) {
          this.dataSubjectsList[stockChartId][apiId].next(data);
        }
        let stockChartData = [];
        if (isStockChartFormat) {
          // currently hard coded for dummy temparature data
          if (apiConfig.apiKeyName === 'TEMPARATURE_CHART') {
            data = this.dataService.deepClone(this.stockChartCustomService.getTemperatureData());
          }
          if(apiConfig.apiKeyName === 'RIVERPOINT_CHART_API'){
            data = data.data;
          }
          stockChartData = this.getStockChartFormatFromData(data, apiConfig);
          observer.next(stockChartData);
        } else {
          observer.next(data);
        }
        observer.complete();
      }, error => {
        observer.next([]);
        if (isHTTPCall) {
          this.dataSubjectsList[stockChartId][apiId].next([]);
        }
        // observer.error(error);
        observer.complete();
      });
    });
  }
  /**
   * return the formatted stock chart array from the api data
   * assign colors from compare config
   * @param data data received from the api
   * @param apiConfig apiConfig for application
   */
  getStockChartFormatFromData(data, apiConfig: StockChartApplicationAPIConfig) {
    if (isEmptyField(data)) {
      return [];
    }
    if (Array.isArray(data)) {
      data = this.dataService.flattenObject(data);
    } else if (isObject(data)) {
      // data = this.dataService.flattenOneObject(data);
      for (let field of Object.keys(data)) {
        if (isObject(data[field])) {
          data[field] = this.dataService.flattenOneObject(data[field]);
        }
      }
    }
    const sortedData = Object.keys(data).sort((a, b) => parseFloat(a) - parseFloat(b)).reduce((accumulator, currentValue) => {
      accumulator[currentValue] = data[currentValue];
      return accumulator;
    }, {});
    // const sortedData = data;
    const stockArray = [];
    for (const indexOrKey of Object.keys(sortedData)) {
      let tmpObj: any = {};
      if (apiConfig.keyField === 'arrayItem') {
        tmpObj.x = convertToFloat(sortedData[indexOrKey]);
      } else if (apiConfig.keyField === 'objectKey') {
        tmpObj.x = convertToFloat(indexOrKey);
      } else if (apiConfig.keyField === 'objectValue') {
        tmpObj.y = convertToFloat(sortedData[indexOrKey],2);
      } else {
        tmpObj.x = convertToFloat(sortedData[indexOrKey][apiConfig.keyField]);
      }

      let timeStampDate = new Date(tmpObj.x);
      timeStampDate.setHours(0, 0, 0);
      tmpObj.x = Date.parse(timeStampDate.toString());

      if (apiConfig.titleField === 'arrayItem') {
        tmpObj.y = (convertToFloat(sortedData[indexOrKey]),2);
      } else if (apiConfig.titleField === 'objectKey') {
        tmpObj.y = convertToFloat(indexOrKey,2);
      } else if (apiConfig.titleField === 'objectValue') {
        tmpObj.y = convertToFloat(sortedData[indexOrKey],2);
      } else if (!isEmptyField(apiConfig.titleField)) {
        tmpObj.y = convertToFloat(sortedData[indexOrKey][apiConfig.titleField],2);
      }
      if (apiConfig.candleStickConfig && !isEmptyObject(apiConfig.candleStickConfig)) {
        tmpObj = this.getCandleStickData(sortedData[indexOrKey], tmpObj, apiConfig);
      }
      if (apiConfig.areaRangeConfig && !isEmptyObject(apiConfig.areaRangeConfig)) {
        tmpObj = this.getAreaRangeData(sortedData[indexOrKey], tmpObj, apiConfig);
      }
      // compare config functionality


      if (!!apiConfig.apiCompareConfig && !isEmptyObject(apiConfig.apiCompareConfig)) {
        const actualValue1 = convertToFloat(sortedData[indexOrKey][apiConfig.titleField],2);
        const compareValue1 = convertToFloat(sortedData[indexOrKey][apiConfig.apiCompareConfig.compareKey],2);
        const multiFactor= apiConfig.apiCompareConfig.multiplicationFactor;
        let actualValue = actualValue1, compareValue = compareValue1;
         if(!isEmptyField(multiFactor)){
          compareValue = multiFactor*compareValue;
        }
        for (const compareType of apiConfig.apiCompareConfig.compareType) {
          if (compareType === 'greater') {
            if (actualValue > compareValue) {
              tmpObj.color = apiConfig.apiCompareConfig.greaterColor;
            }
          }
          if (compareType === 'lesser') {
            if (actualValue < compareValue) {
              tmpObj.color = apiConfig.apiCompareConfig.lesserColor;
            }
          }
          if (compareType === 'equal') {
            if (actualValue === compareValue) {
              tmpObj.color = apiConfig.apiCompareConfig.equalColor;
            }
          }
        }
      }
      stockArray.push(tmpObj);
    }
    // console.log(stockArray, 'stock array here');
    return stockArray;
  }

  getCandleStickData(data, object, config: StockChartApplicationAPIConfig) {
    // if(config.candleStickConfig)
    const candleConfig = config.candleStickConfig;
    if (candleConfig.openField) {
      object.open = convertToFloat(data[candleConfig.openField], 2);
    }
    if (candleConfig.closeField) {
      object.close = convertToFloat(data[candleConfig.closeField], 2);
    }
    if (candleConfig.highField) {
      object.high = convertToFloat(data[candleConfig.highField], 2);
    } else {
      object.high = convertToFloat(data[candleConfig.openField], 2);
    }
    if (candleConfig.lowField) {
      object.low = convertToFloat(data[candleConfig.lowField], 2);
    } else {
      object.low = convertToFloat(data[candleConfig.closeField], 2);
    }
    return object;
  }

  getAreaRangeData(data, object, config: StockChartApplicationAPIConfig) {
    // if(config.candleStickConfig)
    const areaRangeConfig = config.areaRangeConfig;
    if (areaRangeConfig.areaMax) {
      object.areaMax = convertToFloat(data[areaRangeConfig.areaMax], 2);
    } else {
      object.areaMax = null;
    }
    if (areaRangeConfig.areaMin) {
      object.areaMin = convertToFloat(data[areaRangeConfig.areaMin], 2);
    } else {
      object.areaMin = null;
    }
    return object;
  }
  /**
   * whether data is present in the series all applications
   * @param series series data
   */
  isDataPresentInStockChart(series: any[]) {
    if (series.length === 0) {
      return false;
    }
    let dataPresent = false;
    series.forEach(field => {
      if (field.data && field.data.length > 0) {
        dataPresent = true;
      }
    });
    return dataPresent;
  }

  /**
   * return the indicators formatted config
   * @param applicationsConfig chartApplication config from stock config
   */
  getIndicatorsConfig(stockChartConfig: StockChartConfig, geoObject: any): Observable<any> {
    const colorArray = [
      '#63b598', '#ce7d78', '#ea9e70', '#a48a9e', '#c6e1e8', '#648177', '#0d5ac1',
      '#f205e6', '#1c0365', '#14a9ad', '#4ca2f9', '#a4e43f', '#d298e2', '#6119d0',
      '#d2737d', '#c0a43c', '#f2510e', '#651be6', '#79806e', '#61da5e', '#cd2f00',
      '#9348af', '#01ac53', '#c5a4fb', '#996635', '#b11573', '#4bb473', '#75d89e',
      '#2f3f94', '#2f7b99', '#da967d', '#34891f', '#b0d87b', '#ca4751', '#7e50a8',
      '#c4d647', '#e0eeb8', '#11dec1', '#289812', '#566ca0', '#ffdbe1', '#2f1179',
      '#935b6d', '#916988', '#513d98', '#aead3a', '#9e6d71', '#4b5bdc', '#0cd36d',
      '#250662', '#cb5bea', '#228916', '#ac3e1b', '#df514a', '#539397', '#880977',
      '#f697c1', '#ba96ce', '#679c9d', '#c6c42c', '#5d2c52', '#48b41b', '#e1cf3b',
      '#5be4f0', '#57c4d8', '#a4d17a', '#225b8', '#be608b', '#96b00c', '#088baf',
      '#f158bf', '#e145ba', '#ee91e3', '#05d371', '#5426e0', '#4834d0', '#802234',
      '#6749e8', '#0971f0', '#8fb413', '#b2b4f0', '#c3c89d', '#c9a941', '#41d158',
      '#fb21a3', '#51aed9', '#5bb32d', '#807fb', '#21538e', '#89d534', '#d36647',
      '#7fb411', '#0023b8', '#3b8c2a', '#986b53', '#f50422', '#983f7a', '#ea24a3',
      '#79352c', '#521250', '#c79ed2', '#d6dd92', '#e33e52', '#b2be57', '#fa06ec',
      '#1bb699', '#6b2e5f', '#64820f', '#1c271', '#21538e', '#89d534', '#d36647',
      '#7fb411', '#0023b8', '#3b8c2a', '#986b53', '#f50422', '#983f7a', '#ea24a3',
      '#79352c', '#521250', '#c79ed2', '#d6dd92', '#e33e52', '#b2be57', '#fa06ec',
      '#1bb699', '#6b2e5f', '#64820f', '#1c271', '#9cb64a', '#996c48', '#9ab9b7',
      '#06e052', '#e3a481', '#0eb621', '#fc458e', '#b2db15', '#aa226d', '#792ed8',
      '#73872a', '#520d3a', '#cefcb8', '#a5b3d9', '#7d1d85', '#c4fd57', '#f1ae16',
      '#8fe22a', '#ef6e3c', '#243eeb', '#1dc18', '#dd93fd', '#3f8473', '#e7dbce',
      '#421f79', '#7a3d93', '#635f6d', '#93f2d7', '#9b5c2a', '#15b9ee', '#0f5997',
      '#409188', '#911e20', '#1350ce', '#10e5b1', '#fff4d7', '#cb2582', '#ce00be',
      '#32d5d6', '#17232', '#608572', '#c79bc2', '#00f87c', '#77772a', '#6995ba',
      '#fc6b57', '#f07815', '#8fd883', '#060e27', '#96e591', '#21d52e', '#d00043',
      '#b47162', '#1ec227', '#4f0f6f', '#1d1d58', '#947002', '#bde052', '#e08c56',
      '#28fcfd', '#bb09b', '#36486a', '#d02e29', '#1ae6db', '#3e464c', '#a84a8f',
      '#911e7e', '#3f16d9', '#0f525f', '#ac7c0a', '#b4c086', '#c9d730', '#30cc49',
      '#3d6751', '#fb4c03', '#640fc1', '#62c03e', '#d3493a', '#88aa0b', '#406df9',
      '#615af0', '#4be47', '#2a3434', '#4a543f', '#79bca0', '#a8b8d4', '#00efd4',
      '#7ad236', '#7260d8', '#1deaa7', '#06f43a', '#823c59', '#e3d94c', '#dc1c06',
      '#f53b2a', '#b46238', '#2dfff6', '#a82b89', '#1a8011', '#436a9f', '#1a806a',
      '#4cf09d', '#c188a2', '#67eb4b', '#b308d3', '#fc7e41', '#af3101', '#ff065',
      '#71b1f4', '#a2f8a5', '#e23dd0', '#d3486d', '#00f7f9', '#474893', '#3cec35',
      '#1c65cb', '#5d1d0c', '#2d7d2a', '#ff3420', '#5cdd87', '#a259a4', '#e4ac44',
      '#1bede6', '#8798a4', '#d7790f', '#b2c24f', '#de73c2', '#d70a9c', '#25b67',
      '#88e9b8', '#c2b0e2', '#86e98f', '#ae90e2', '#1a806b', '#436a9e', '#0ec0ff',
      '#f812b3', '#b17fc9', '#8d6c2f', '#d3277a', '#2ca1ae', '#9685eb', '#8a96c6',
      '#dba2e6', '#76fc1b', '#608fa4', '#20f6ba', '#07d7f6', '#dce77a', '#77ecca'];
    let childAPISubjects: BehaviorSubject<any>;


    const childAPIData: any = {};
    let childExist = false;
    return new Observable(observer => {
      const applicationsConfig = stockChartConfig.applicationConfig;
      const indicatorsConfig = {};


      for (const application of Object.keys(applicationsConfig)) {
        const config = applicationsConfig[application];
        if (!isEmptyField(config.childConfigId)) {
          childExist = true;
          childAPISubjects = new BehaviorSubject<any>({});
        }
      }
      if (childExist) {
        const subscribtion = childAPISubjects.subscribe(data => {
          if (isEmptyField(Object.keys(data)[0])) {
            return;
          }
          childAPIData[Object.keys(data)[0]] = data[Object.keys(data)[0]];
          let isUpdate = true;
          for (const application of Object.keys(childAPIData)) {
            if (data[application] === false) {
              isUpdate = false;
            }
          }
          if (isUpdate) {
            observer.next([stockChartConfig, indicatorsConfig]);
            subscribtion.unsubscribe();
          }
        });
      }


      for (const application of Object.keys(applicationsConfig)) {
        const config = applicationsConfig[application];
        let geoConfigObject: any = {};
        if (childExist) {
          const hierarchyId = !isEmptyField(config.hierarchyId) ? config.hierarchyId : stockChartConfig.geographicalConfig.hierarchyId;
          const serviceConfigObj = {
            location: true,
            parent: true,
            child: true,
            allParents: true
          };
          geoConfigObject =   this.stockChartGeoService.extractLocationInformation(serviceConfigObj, geoObject.rawLocation, hierarchyId);
        }
        if (isEmptyObject(config.rendererConfig)) {
          continue;
        } else {
          let tmpObj: any = {};
          tmpObj = config.rendererConfig;
          tmpObj.title = childExist ? geoConfigObject.location + ' ' + config.title : config.title;
          tmpObj.unit = config.unit;
          indicatorsConfig[application] = tmpObj;
          if (!isEmptyField(config.childConfigId)) {
            if (!isEmptyField(stockChartConfig.geographicalConfig) && !isEmptyObject(stockChartConfig.geographicalConfig)) {
              const sampleSubjectObject = {};
              sampleSubjectObject[application] = false;
              childAPISubjects.next(sampleSubjectObject);
              const mainAPIConfigObject = stockChartConfig.geographicalConfig.childAPIConfig[config.childConfigId];
              if (geoConfigObject.parentsArray) {
                geoConfigObject.parentsArray.forEach(element => {
                  const applicationReplica: ChartApplicationConfig = this.dataService.deepClone(config);
                  applicationReplica.title = element.location + ' ' + config.title;
                  applicationReplica.id = element.location + '_' + application;
                  applicationReplica.apiConfig.apiId = element.location + '_' + application;
                  applicationReplica.apiConfig.postData.location = element.location;
                  applicationReplica.apiConfig.postData.isChildApplication = true;
                  applicationReplica.apiConfig.postData.locationType = element.parent;
                  applicationReplica.isParentApplication = true;
                                      // for now using the login of stock chart format data
                  const tmpObj = this.dataService.deepClone(config.rendererConfig);
                  tmpObj.title = element.location + ' ' + config.title;
                  tmpObj.unit = config.unit;
                  tmpObj.visible = false;
                  tmpObj.chartColor = colorArray[Math.floor((Math.random() * 230))];
                  indicatorsConfig[element.location + '_' + application] = tmpObj;
                  stockChartConfig.applicationConfig[element.location + '_' + application] = applicationReplica;
                });
              }
              if (stockChartConfig.geographicalConfig.childAPIConfig && mainAPIConfigObject) {
                const childAPIConfig: StockChartGeographicAPIConfig = !isEmptyField(mainAPIConfigObject[geoConfigObject.parent]) ? mainAPIConfigObject[geoConfigObject.parent] : mainAPIConfigObject.common;
                childAPIConfig.postData = this.generatePostData(childAPIConfig, geoConfigObject);
                this.httpService.placeAPICall(childAPIConfig).subscribe(data => {
                  const formattedData: any = this.getStockChartFormatFromData(data, childAPIConfig);
                  formattedData.forEach(element => {
                    const applicationReplica: ChartApplicationConfig = this.dataService.deepClone(config);
                    applicationReplica.title = element.y + ' ' + config.title;
                    applicationReplica.id = element.y + '_' + application;
                    applicationReplica.apiConfig.apiId = element.y + '_' + application;
                    applicationReplica.apiConfig.postData.location = element.y;
                    applicationReplica.apiConfig.postData.isChildApplication = true;
                    applicationReplica.apiConfig.postData.locationType = geoConfigObject.child;
                    applicationReplica.isChildApplication = true;
                    // for now using the login of stock chart format data
                    const tmpObj = this.dataService.deepClone(config.rendererConfig);
                    tmpObj.title = element.y + ' ' + config.title;
                    tmpObj.unit = config.unit;
                    tmpObj.visible = false;
                    tmpObj.chartColor = colorArray[Math.floor((Math.random() * 230))];
                    indicatorsConfig[element.y + '_' + application] = tmpObj;
                    stockChartConfig.applicationConfig[element.y + '_' + application] = applicationReplica;
                  });
                  const sampleSubjectObject = {};
                  sampleSubjectObject[application] = true;
                  childAPISubjects.next(sampleSubjectObject);
                }, error => {
                  const sampleSubjectObject = {};
                  sampleSubjectObject[application] = true;
                  childAPISubjects.next(sampleSubjectObject);
                });
              }
            }
          }
        }
      }
      if (!childExist) {
        observer.next([stockChartConfig, indicatorsConfig]);
      }
    });
    // return indicatorsConfig;
  }
  /**
   * can extend these function in future for addition of more things as a post params
   * @param postData postdata
   * @param geoConfig geoconfig means which fields need to add
   * @param geoStateObject geostateobject will contain the details of location and all
   */
  generatePostData(apiConfig: StockChartGeographicAPIConfig, geoStateObject) {
    if (!isEmptyField(apiConfig.geoGraphicObjectConfig) && !isEmptyObject(apiConfig.geoGraphicObjectConfig)) {
      for (const param of Object.keys(apiConfig.geoGraphicObjectConfig)) {
        if (!isEmptyField(geoStateObject[param])) {
          apiConfig.postData[apiConfig.geoGraphicObjectConfig[param]] = geoStateObject[param];
        }
      }
    }
    if (!isEmptyField(apiConfig.postDataFormatter) && !isEmptyObject(apiConfig.postDataFormatter)) {
      if (apiConfig.postDataFormatter.functionName) {
        try {
          apiConfig.postData = this.stockChartCustomService[apiConfig.postDataFormatter.functionName](apiConfig.postData, apiConfig.postDataFormatter.paramObject);
        } catch (e) {
          console.log('postdata formatter function error in stock chart service');
        }
      } else if (apiConfig.postDataFormatter.formatter) {
        apiConfig.postData = apiConfig.postDataFormatter.formatter(apiConfig.postData);
      }
    }
    return apiConfig.postData;
  }
}
